import { render, staticRenderFns } from "./rtuList2.vue?vue&type=template&id=3d477fd6&scoped=true"
import script from "./rtuList2.vue?vue&type=script&lang=js"
export * from "./rtuList2.vue?vue&type=script&lang=js"
import style0 from "./rtuList2.vue?vue&type=style&index=0&id=3d477fd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d477fd6",
  null
  
)

export default component.exports